/*eslint-disable-*/
import axios from "axios";

export default {
    methods: {
        GTMCheckoutEvents(cart) {
            this.trackFunnelCheckout(this.prepareProductsForEvents(cart));
        },
        /**
         * Normalize package/cart/factor product shapes into a common ecommerce product.
         */
        normalizeProductForEvents(raw) {
            if (!raw) return null;

            // Basket cart line: { item: {id,title}, price, qty }
            if (raw.item && (raw.item.id != null || raw.item.title)) {
                return {
                    name: raw.item.title || '',
                    id: raw.item.id,
                    price: raw.price != null ? raw.price : (raw.item.pivot && raw.item.pivot.price),
                    brand: 'Simiaroom',
                    category: 'Counseling',
                    quantity: Number(raw.qty != null ? raw.qty : raw.quantity) || 1,
                };
            }

            // Journey cart_packages row: { package, package_id, ... } or nested package
            const pkg = raw.package || raw;
            const pivot = pkg.pivot || raw.pivot || {};
            const id = pkg.id != null ? pkg.id : (raw.package_id != null ? raw.package_id : raw.id);
            const name = pkg.title || pkg.en_title || pkg.name || raw.title || raw.name || '';
            const price = pivot.final_price != null
                ? pivot.final_price
                : (pivot.price != null
                    ? pivot.price
                    : (pkg.price != null ? pkg.price : (raw.price != null ? raw.price : 0)));
            const quantity = Number(pivot.quantity != null ? pivot.quantity : (raw.quantity != null ? raw.quantity : 1)) || 1;

            if (id == null && !name) return null;

            return {
                name,
                id,
                price,
                brand: 'Simiaroom',
                category: 'Counseling',
                quantity,
            };
        },
        /**
         * Shared add-to-cart funnel: GA4 dataLayer + WebEngage + Trk.
         * Uses window.dataLayer directly (same as purchase) — vue-gtm has no container id.
         */
        trackFunnelAddToCart(rawProduct, extras = {}) {
            const product = this.normalizeProductForEvents(rawProduct);
            if (!product) return null;

            const itemId = extras.item_id != null ? extras.item_id : product.id;
            const itemName = extras.item_name || extras.doctor_name || product.name || '';
            const doctorName = extras.doctor_name || '';
            const price = Number(product.price) || 0;
            const quantity = Number(product.quantity) || 1;

            const items = [{
                item_id: String(itemId != null ? itemId : ''),
                item_name: itemName,
                doctor_name: doctorName,
                price,
                quantity,
                session_type: extras.session_type || '',
            }];

            const payload = {
                event: 'add_to_cart',
                doctor_name: doctorName,
                ecommerce: {
                    currency: extras.currency || 'IRR',
                    value: price * quantity,
                    items,
                },
            };

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push(payload);

            if (window.webengage) {
                this.sendToWebengage('add_to_cart', product);
            }

            const profile = (this.$store && this.$store.getters && this.$store.getters.getProfile) || this.profile;
            if (profile && typeof this.SendEventTrk === 'function') {
                this.SendEventTrk({
                    event_id: 'add_to_cart' + Date.now(),
                    name: 'add_to_cart',
                    email: profile.email,
                    first_name: profile.firstname,
                    last_name: profile.lastname,
                    payload: {
                        product_name: itemName || product.name,
                        product_id: itemId,
                        doctor_name: doctorName,
                    },
                });
            }

            return payload;
        },
        /**
         * Shared checkout funnel: GA4 begin_checkout + WebEngage proceed_to_payment.
         */
        trackFunnelCheckout(productsOrRawList, extras = {}) {
            const list = Array.isArray(productsOrRawList) ? productsOrRawList : [];
            const products = list
                .map((item) => this.normalizeProductForEvents(item))
                .filter(Boolean);

            const doctorName = extras.doctor_name || '';
            const items = products.map((product) => ({
                item_id: String(
                    extras.item_id != null ? extras.item_id : (product.id != null ? product.id : '')
                ),
                item_name: extras.item_name || doctorName || product.name || '',
                doctor_name: doctorName,
                price: Number(product.price) || 0,
                quantity: Number(product.quantity) || 1,
                session_type: extras.session_type || '',
            }));

            const value = items.reduce((sum, item) => sum + (item.price * item.quantity), 0);

            const payload = {
                event: 'begin_checkout',
                doctor_name: doctorName,
                ecommerce: {
                    currency: extras.currency || 'IRR',
                    value,
                    items,
                },
            };

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push(payload);

            this.payBtnId = 'ga_payment_button';
            this.WebengageProceedToPayment();

            return payload;
        },
        WebengageSetUserLoggedIn(userID) {
            if (window.webengage && localStorage.getItem('webengage_login') != 'true') {
                window.webengage.user.login(userID);
                localStorage.setItem('webengage_login', true)
            }
        },
        WebengageSetUserRequiredFiled(profile) {
            this.WebengageSetUserLoggedIn(profile.id)
            if (window.webengage) {
                if (profile.email) {
                    window.webengage.user.setAttribute("we_email", profile.email);
                }
                if (profile.cel) {
                    window.webengage.user.setAttribute("we_phone", profile.cel.replaceAll(' ', ''));
                }
            }
        },
        WebengageUserRegister(userId, register_on, email, phone = null, fromTest = false) {
            if (window.webengage) {
                try {
                    if (register_on) {
                        window.webengage.user.setAttribute("registered_on", register_on);
                    }
                    if (email) {
                        window.webengage.user.setAttribute("we_email", email);
                    }
                    if (phone) {
                        window.webengage.user.setAttribute("we_phone", phone.replaceAll(' ', ''));
                    }
                    if (fromTest) {
                        window.webengage.track('registered_on', {
                            date: register_on,
                            type: 'psyregister'
                        });
                    } else {
                        window.webengage.track('registered_on', {
                            date: register_on,
                        });
                    }
                    this.WebengageSetUserLoggedIn(userId)
                    console.log('sent register data to web engage')
                } catch (error) {
                    console.log('have problem in send data to webengage' + error)
                }
            }
            // console.log('ok')
        },
        WebengageProceedToPayment() {
            this.sendToWebengage('proceed_to_payment')
        },
        CouponCodeWebengageTrack(code, status) {
            let payload = {
                code: code
            }
            if (status == 'success') {
                this.sendToWebengage('promotion_code_success', payload)
            } else if (status == 'failed') {
                this.sendToWebengage('promotion_code_failure', payload)
            }
        },
        sendToWebengage(event, data) {
            if (window.webengage) {
                window.webengage.track(event, data);
            }
        },
        sendAddToCartEvents(resp) {
            let addedPackage = resp.data.package;
            let product = {
                'name': addedPackage.title,
                'id': addedPackage.id,
                'price': addedPackage.pivot.price,
                'brand': 'Simiaroom',
                'category': 'Counseling',
                'quantity': 1
            };

            if (window.webengage) {
                window.webengage.track('add_to_cart', product);
            }

            this.$gtm.trackEvent({
                'event': 'eec.addToCart',
                'ecommerce': {
                    'add': {
                        'products': [product]
                    }
                }
            });
        },
        prepareProductsForEvents(cart) {
            let products = [];
            Object.keys(cart.items).forEach((key) => {
                let item = cart.items[key];
                products.push({
                    'name': item.item.title,
                    'id': item.item.id,
                    'price': item.price,
                    'brand': 'Simiaroom',
                    'category': 'Counseling',
                    // 'variant': 'Gray',
                    'quantity': item.qty
                })
            })
            return products
        },
        GTMAddToCart(item) {
            this.$gtm.trackEvent({
                'event': 'eec.addToCart',
                'ecommerce': {
                    'add': {
                        'products': [{
                            'name': item.item.title,
                            'id': item.item.id,
                            'price': item.price,
                            'brand': 'Simiaroom',
                            'category': 'Counseling',
                            // 'variant': 'Gray',
                            'quantity': 1
                        }]
                    }
                }
            });
        },
        WebengageAddToCart(item) {
            let product = {
                'name': item.item.title,
                'id': item.item.id,
                'price': item.price,
                'brand': 'Simiaroom',
                'category': 'Counseling',
                'quantity': 1
            };

            this.sendToWebengage('add_to_cart', product)

        },

        GTMRemoveFromCart(item) {
            this.$gtm.trackEvent({
                'event': 'eec.removeFromCart',
                'ecommerce': {
                    'remove': {                               // 'remove' actionFieldObject measures.
                        'products': [{
                            'name': item.item.title,
                            'id': item.item.id,
                            'price': item.price,
                            'brand': 'Simiaroom',
                            'category': 'Counseling',
                            // 'variant': 'Gray',
                            'quantity': 1
                        }]
                    }
                }
            });
        },
        WebEngagePreSessionSet(data) {
            if (window.webengage) {
                window.webengage.track('book_pre_session', data);
            }
        },
        RegisterUserInTrk() {
            if (localStorage.getItem('trk_id')) {
                return Promise.resolve()
            }

            const profile = this.$store.getters.getProfile
            if (!profile) {
                return Promise.resolve()
            }

            const phone = profile.mobile || profile.cel
            if (!phone) {
                return Promise.resolve()
            }

            const anon = this.generateRandomAnonId();
            localStorage.setItem('anon', anon)
            const payload = {
                anon_id: anon,
                phone,
                first_name: null,
                traits: {}
            }
            return axios.post('https://trk.roobroo.ir/webhook/identify', payload).then(() => {
                localStorage.setItem('trk_id', anon)
            })
        },
        generateRandomAnonId() {
            const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let result = '';
            for (let i = 0; i < 12; i++) {
                result += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            return result;
        },
        SendEventTrk(data) {
            const profile = this.$store.getters.getProfile || {}
            const rawEmail = data.email ?? profile.email ?? null
            const email = rawEmail && !/noemail/i.test(String(rawEmail)) ? rawEmail : null

            const payload = {
                event_id: data.event_id,
                anon_id: localStorage.getItem('trk_id'),
                name: data.name,
                first_name: data.first_name ?? profile.firstname ?? profile.name ?? null,
                last_name: data.last_name ?? profile.lastname ?? profile.family ?? null,
                email,
                phone: data.phone ?? profile.mobile ?? profile.cel ?? null,
                properties: data.payload ?? {},
                auth_id: profile.auth_id ?? null,
                occurred_at: new Date().toISOString()
            }
            return axios.post('https://trk.roobroo.ir/webhook/track', payload)
        },
        SetAttributeTrackerService(email, payload) {
            const rawEmail = email && !/noemail/i.test(String(email)) ? email : null
            if (!rawEmail) {
                return Promise.resolve()
            }

            const body = {
                email: rawEmail,
                attributes: payload
            }
            return axios.post('https://trk.roobroo.ir/events-core/set-attribute', body)
        },
    }
}